import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import DashboardPage from './pages/DashboardPage';
import ReferralPage from './pages/ReferralPage';
import PaymentPage from './pages/PaymentPage';
import PrivateRoute from './privateRoutes/PrivateRoute';
import ProtectedRoute from './privateRoutes/ProtectedRoute';
import { ROLES } from './permissions/permissions';
import './scss/main.scss';
import './index.css';

import UserProfile from './pages/UserProfile';
import AdminProfile from './pages/admin/AdminProfile';
import RecoverPassword from './components/auth/RecoverPassword';
import ResetPassword from './components/auth/ResetPassword';
import PaymentFile from './pages/admin/PaymentFile';
import AllReferrals from './pages/admin/AllReferrals';
import AllReferralCodes from './pages/admin/AllReferralCodes';
import ImpersonateUser from './pages/admin/ImpersonateUser';
import PaymentApproval from './pages/admin/paymentApproval';
import InviteReferrals from './pages/referralChange/InviteReferrals';
import AcceptInvitation from './pages/referralChange/AcceptInvitation';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Rutas públicas */}
          <Route path="login" element={<LoginForm />} />
          <Route index element={<Navigate to="/login" />} />
          <Route path="register" element={<RegisterForm />} />
          <Route path="recovery" element={<RecoverPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="/accept-invitation" element={<AcceptInvitation />} />

          {/* Rutas privadas para usuarios */}
          <Route element={<PrivateRoute><MainLayout /></PrivateRoute>}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/referrals" element={<ReferralPage />} />
            <Route path="/payments" element={<PaymentPage />} />
            <Route path="/profile" element={<UserProfile />} />

            {/* cambio de referidos */}
            <Route path="/invite-referrals" element={<InviteReferrals />} />
          </Route>

          {/* Rutas privadas para administradores */}
          <Route element={<ProtectedRoute roles={[ROLES.ADMIN, ROLES.AUDITOR]}><AdminLayout /></ProtectedRoute>}>
            <Route
              path="/admin/payment-file"
              element={
                <ProtectedRoute roles={[ROLES.ADMIN]}>
                  <PaymentFile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/impersonate"
              element={
                <ProtectedRoute roles={[ROLES.ADMIN]}>
                  <ImpersonateUser />
                </ProtectedRoute>
              }
            />
            <Route path="/admin/all-referrals" element={<AllReferrals />} />
            <Route path="/admin/profile" element={<AdminProfile />} />
            <Route path="/admin/all-referral-codes" element={<AllReferralCodes />} />
            <Route path="/admin/payment-approval" element={<PaymentApproval />} />
          </Route>

          {/* Redirección para rutas no encontradas */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;